import {media} from '@sail/engine';
import {css, tokens} from '@sail/ui';

export const styles = {
  container: css({
    textColor: '#fff',
    borderRadius: 'medium',
    gap: 'space.0',
    distribute: 'space-between',
  }),

  quoteContainer: css({
    position: 'relative',
    margin: 'space.0',
    stack: 'y',
    gap: 'medium',
  }),

  quoteFooter: css({
    font: 'body.medium',
  }),

  quoteBody: css({
    margin: 'space.0',
    font: 'body.large',
    ':before': {
      content: 'open-quote',
      position: 'absolute',
      left: '-10px',
    },
    ':after': {
      content: 'close-quote',
      marginLeft: 'xsmall',
    },
  }),

  quoteAuthor: css({
    font: 'body.medium',
    fontWeight: '500',
    margin: 'space.0',
  }),

  logoSvg: css({
    [media.up(tokens.viewport.large)]: {
      width: 'fill',
    },
    height: 'fill',
    maxHeight: '60px',
  }),
  logoSvgUnprocessed: css({
    '--userLogoColor': '#fff',
  }),
};
